import {usePanelManager} from '@tritt/multipanel'
import {ACCOUNTS_PAYABLE, ACCOUNTS_RECEIVABLE, CUSTOMERS, SUPPLIERS} from '@/subaccount'
import {CREATE_TRANSACTION} from '@/transaction/create-transaction'
import {useSplitpanes} from '@tritt/multipanel'
import {ORGS} from '@/tenants'
import {TASKS} from '@/task-manager'
import {TRIAL_BALANCE} from '@/tribal'
import {GENERAL_LEDGER} from '@/genleg'
import {PROFIT_AND_LOSS} from '@/proflos'
import {BALANCE} from '@/balrep'
import {PanelContent} from '@tritt/multipanel'


export type Layout = {
    name: string,
    layoutId: string,
    icon: string,
    content: PanelContent[],
    widthOverride?: { paneId: number, width: number }
}


const layouts: Layout[] = [
    {
        name: 'Bilagsmottak',
        layoutId: '1',
        icon: 'i-mdi-file-document-multiple',
        content: [TASKS, CREATE_TRANSACTION, TRIAL_BALANCE, GENERAL_LEDGER]
    },
    {
        name: 'Bilagsmottak multiklient',
        layoutId: '2',
        icon: 'i-mdi-file-document-multiple',
        content: [ORGS, TASKS, CREATE_TRANSACTION, TRIAL_BALANCE],
        widthOverride: {paneId: 0, width: 450}
    },
    {
        name: 'Rapporter',
        layoutId: '3',
        icon: 'i-ph-chart-bar-fill',
        content: [PROFIT_AND_LOSS, BALANCE, ACCOUNTS_RECEIVABLE, ACCOUNTS_PAYABLE]
    },
    {
        name: 'Kunder / leverandører',
        layoutId: '4',
        icon: 'i-ph-users-three-fill',
        content: [CUSTOMERS, ACCOUNTS_RECEIVABLE, SUPPLIERS, ACCOUNTS_PAYABLE]
    }
]


export const useFavoriteLayouts = () => {

    const activateLayout = async (layout: Layout) => {
        const {setPanelPath} = usePanelManager()
        for (let i = 0; i < layout.content.length; i++) {
            const content = layout.content[i]
            await setPanelPath({...content, panelId: (i + 1)})

        }
        if (layout.widthOverride) {
            const {setPanelSize} = useSplitpanes()
            setPanelSize(layout.widthOverride.paneId, layout.widthOverride.width)
        }
    }

    return {
        layouts,
        activateLayout
    }

}